"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bottom = exports.Company = exports.Email = exports.Name = exports.ContentWrapper = exports.AvatarWrapper = exports.Top = exports.ProfileBoxWrapper = void 0;
exports.ProfileBox = ProfileBox;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const account_context_1 = require("@src/context/account-context");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importStar(require("styled-components"));
exports.ProfileBoxWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	text-transform: none;
	font-weight: normal;
`;
exports.Top = styled_components_1.default.button `
	display: flex;
	cursor: pointer;
	border: 0;
	padding: 0;
	overflow: hidden;
	text-align: left;
	background: ${props => props.theme.color.white};
	border-radius: ${props => props.theme.borderRadius.base};
	transition: all 0.1s ease;
	border: 1px solid ${props => props.theme.color.white};

	&:hover {
		background: ${props => props.theme.color.gray2};
		border: 1px solid ${props => props.theme.color.gray3};
	}
`;
exports.AvatarWrapper = styled_components_1.default.div `
	margin: 0.5rem 1rem 0.5rem 0.5rem;
	border-radius: ${props => props.theme.borderRadius.base};
	display: flex;
`;
exports.ContentWrapper = styled_components_1.default.div `
	padding: 0 0.5rem 0 0;
	display: flex;
	flex-direction: column;
	align-self: center;
	overflow: hidden;
`;
exports.Name = styled_components_1.default.div `
	font-size: 1rem;
	font-weight: bold;
	line-height: 1.3;
	color: ${props => props.theme.color.brand1};
	${props => props.marginTop &&
    (0, styled_components_1.css) `
			margin-top: 0.5rem;
		`}
`;
exports.Email = styled_components_1.default.div `
	line-height: 1.3;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: ${props => props.theme.color.gray6};
`;
exports.Company = styled_components_1.default.div `
	margin: 0.5rem 0;
	line-height: 1.3;
	color: ${props => props.theme.color.gray7};
`;
exports.Bottom = styled_components_1.default.div `
	margin-top: 0.5rem;
	display: flex;
	gap: 0.5rem;
	align-self: flex-end;
	justify-content: space-between;
`;
function ProfileBox({ onLogoutClick, onAccountClick, image, name, email, company, companyUrl }) {
    const theme = (0, styled_components_1.useTheme)();
    const account = (0, account_context_1.useAccount)();
    return ((0, jsx_runtime_1.jsxs)(exports.ProfileBoxWrapper, { children: [(0, jsx_runtime_1.jsxs)(exports.Top, { onClick: onAccountClick, children: [(0, jsx_runtime_1.jsx)(exports.AvatarWrapper, { children: (0, jsx_runtime_1.jsx)(StyledAvatar, { account: account, shape: "square", size: 70, src: image, color: theme.color.gray4, contain: true }) }), (0, jsx_runtime_1.jsxs)(exports.ContentWrapper, { children: [(0, jsx_runtime_1.jsx)(exports.Name, { marginTop: !!company, children: name }), (0, jsx_runtime_1.jsx)(exports.Email, { title: email, children: email }), company && (0, jsx_runtime_1.jsx)(exports.Company, { children: company })] })] }), (0, jsx_runtime_1.jsxs)(exports.Bottom, { children: [company && ((0, jsx_runtime_1.jsx)(elements_1.Button, { size: "small", type: "link", link: `/firma/${companyUrl}`, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.profile_public_company" }) })), (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "small", danger: true, type: "primary", onClick: onLogoutClick, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.log_off" }) })] })] }));
}
const StyledAvatar = (0, styled_components_1.default)(elements_1.Avatar) `
	&& svg {
		width: 4rem;
		height: 4rem;
	}
`;
